package br.com.texeratx.boardgametimeapp.ui.screens.games.detail

import br.com.texeratx.boardgametimeapp.domain.usecases.games.DeleteGameUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGameDetailUseCase
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class GameDetailViewModel(
    private val getGameDetailUseCase: GetGameDetailUseCase,
    private val deleteGameUseCase: DeleteGameUseCase,
) : ScreenModel {

    val isSaving = MutableStateFlow(false)
    val uiMessage = MutableStateFlow<String?>(null)
    val game = MutableStateFlow<GameDetailUIModel?>(null)
    val isLoading = MutableStateFlow(false)
    val error = MutableStateFlow<String?>(null)


    fun loadGame(gameId: Long) {
        screenModelScope.launch {
            isLoading.value = true
            error.value = null

            getGameDetailUseCase(gameId)
                .onSuccess {
                    game.value = it
                }
                .onFailure {
                    error.value = it.message
                }

            isLoading.value = false
        }
    }

    fun deleteGame(
        gameId: Long,
        onSuccess: () -> Unit
    ) {
        screenModelScope.launch {
            isSaving.value = true

            deleteGameUseCase(gameId)
                .onSuccess {
                    onSuccess()
                }
                .onFailure {
                    uiMessage.value = it.message ?: "NÃ£o foi possÃ­vel deletar o jogo."
                }

            isSaving.value = false
        }
    }
}
